import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DescargasService {
    private apiUrlToken = `${ENV.HOST}${URL_MAP.API.DOWNLOAD_TOKEN}`;
    private apiUrlReporte = `${ENV.HOST}${URL_MAP.API.DOWNLOAD_REPORTE}`;

    constructor(private http: HttpClient) { }

    crearTokenDescarga(body: any): Observable<String> {
        return this.http.post(`${this.apiUrlToken}`, body, {
            responseType: 'text',
        });
    }

    descargarPdfPorToken(body: { token: string; documento: string; tipo: string }): Observable<Blob> {
    return this.http.post(
      `${this.apiUrlReporte}`,
      body,
      { responseType: 'blob' }
    );
  }

  descargarDirectoGet(token: string, documento: string) {
        const url = `${this.apiUrlReporte}/${token}/${documento}`;
        
        window.location.href = url;
    }

  forceDownload(blob: Blob, filename: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
}